module.exports = __webpack_public_path__ + "static/media/ichef.8df4e1f3.jpg";